import { QueryClient } from "@tanstack/react-query";

/**
 * Shared React Query client. Keeps in-flight request deduplication and cache
 * for notification polling / panel fetches (see TopMenu).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnReconnect: true,
      // Default staleTime > 0 keeps data “fresh” briefly so refetchOnMount and
      // refetchOnWindowFocus do not hammer the same endpoint when many hooks mount
      // or the tab regains focus in quick succession (staleTime: 0 is the library default).
      staleTime: 30_000,
    },
  },
});
